import { useQuery } from '@tanstack/react-query';
import { getSubdomain, isValidSubdomain } from '@zealy/utils';
import { tiktokCampaignKeys } from '../tiktokCampaign.keys';
import { getUserRank } from '../tiktokCampaign.service';
/**
 * Queries the current user's rank in a TikTok campaign
 * @param subdomain The subdomain of the community to query, @default subdomain will be inferred from the URL
 * @param tiktokCampaignId The ID of the TikTok campaign
 * @param enabled Whether the query should be enabled
 * @example const { data, isLoading } = useUserRank('my-community', 'campaign-id');
 */
export const useUserRank = (subdomain, tiktokCampaignId, enabled = true) => {
    const domain = subdomain || getSubdomain();
    return useQuery({
        queryKey: tiktokCampaignKeys.userRank(domain, tiktokCampaignId || ''),
        queryFn: async () => {
            if (!tiktokCampaignId) {
                throw new Error('tiktokCampaignId is required');
            }
            return getUserRank(domain, tiktokCampaignId);
        },
        enabled: isValidSubdomain(domain) && !!tiktokCampaignId && enabled,
        retry: 1,
    });
};
